<template>
  <div class="contract_browse">
    <van-sticky>
      <van-nav-bar title="上传合同" left-arrow @click-left="goback()" />
    </van-sticky>
    <van-form label-width="140" :show-error="false" @submit="onSubmit" error-message-align="right">
      <van-cell-group>
        <van-field required input-align="right" label="签订时间" placeholder="请选择签订时间" is-link @click="showData = true" readonly v-model="submitData.signTime" :rules="[{ required: true, message: '请选择签订时间' }]" />
        <van-field required input-align="right" label="到期日期" placeholder="请选择到期日期" is-link @click="showEndData = true" readonly v-model="submitData.expirationTime" :rules="[{ required: true, message: '请选择到期日期' }]" />
        <van-field required input-align="right" label="合同照片" readonly class="data_idcard" v-model="submitData.fileIdList" :rules="[{ required: true, message: '请上传合同照片' }]">
          <template #input>
            <div class="data_idcard">
              <div class="idcard_img">
                <van-uploader :max-count="10" :max-size="100000*1024" fit="scale-down" :before-read="beforeRead" class="img_license" v-model="uploader" :after-read="afterRead" multiple :before-delete="deleteUploadImg">
                  <van-icon name="plus" size="40" color="#898989" />
                  <div>上传合同照片</div>
                </van-uploader>
              </div>
            </div>
          </template>
        </van-field>
      </van-cell-group>
      <van-button color="#0CA7F0" block native-type="submit">确认提交</van-button>
    </van-form>
    <!-- <van-calendar type="single" v-model="showData" :max-date="maxDate" @confirm="onConfirmData" /> -->
    <!-- <van-calendar type="single" v-model="showEndData" :max-date="maxDate" @confirm="onConfirmEndData" /> -->
    <van-popup v-model="showData" position="bottom">
      <van-datetime-picker type="date" :min-date="minDate" :max-date="maxDate" @confirm="onConfirmData" @cancel="showData = false" />
    </van-popup>
    <van-popup v-model="showEndData" position="bottom">
      <van-datetime-picker type="date" :min-date="minDate" :max-date="maxDate" @confirm="onConfirmEndData" @cancel="showEndData = false" />
    </van-popup>
  </div>
</template>
<script>
import {
  NavBar,
  Button,
  Cell,
  Image,
  Uploader,
  Icon,
  Calendar,
  DatetimePicker,
  Form,
  Field,
  CellGroup,
} from "vant";
import storage from "@/utils/storage";
import { Popup } from 'vant';
export default {
  components: {
    [Popup.name]: Popup,
    [Button.name]: Button,
    [Cell.name]: Cell,
    [Image.name]: Image,
    [NavBar.name]: NavBar,
    [Uploader.name]: Uploader,
    [Icon.name]: Icon,
    [Calendar.name]: Calendar,
    [DatetimePicker.name]: DatetimePicker,
    [Form.name]: Form,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
  },
  data() {
    return {
      submitData: {
        // order_info_id: 0,
        // signTime: "",
        // expirationTime: "",
        // fileIdList: [],
        // fileIdList: ["405", "406", "407"],
        fileIdList: [],
      },
      showData: false,
      showEndData: false,
      uploader: [],
      minDate: '',
      maxDate: ''
    };
  },

  created() {
    //订单-合同浏览
    this.contractuserH5Detail(this.$route.query.id);
    this.getCurrentTime()

  },

  methods: {
    // 时间 范围
    getCurrentTime() {
      //获取当前时间并打印
      let yy = new Date().getFullYear();
      let mm = new Date().getMonth();
      let dd = new Date().getDate();
      this.minDate = new Date(yy, mm, dd);
      this.maxDate = new Date(yy + 10, mm, dd);
    },

    // 返回布尔值
    beforeRead(file) {
      if (file.type !== 'image/jpeg' && file.type !== 'image/png' && file.type !== 'image/jpg') {
        this.$Notify({ type: 'warning', message: '请上传jpg/png格式图片' })
        return false
      } else if (file.size > 10000000 * 1024) {
        this.$Notify({ type: 'warning', message: '图片大小限制10000000KB' })
        return false;
      }
      return true;
    },

    //订单-合同浏览
    contractuserH5Detail(id) {
      var that = this;
      var fileIdList = [];
      that.$api
        .contractuserH5DetailAPI({ order_info_id: id })
        .then(function(res) {
          if (res.data.code === 200) {
            if (res.data.data.contractImageList.length > 0) {
              res.data.data.contractImageList.forEach((element) => {
                fileIdList.push(element.id);
              });
            }
            res.data.data.order_info_id = id;
            res.data.data.fileIdList = fileIdList;
            that.uploader = res.data.data.contractImageList;
            that.submitData = res.data.data;
          }
        })
        .catch(function(err) {
          console.log("error");
        });
    },

    //日期格式化
    formatDate(date) {
      return `${date.getFullYear()}-${date.getMonth() > 9 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1)
        }-${ date.getDate() > 9 ? date.getDate() : "0" + (date.getDate() ) }`;
    },

    onConfirmData(date) {
      this.showData = false;
      console.log('date', date, this.formatDate(date))
      this.submitData.signTime = this.formatDate(date);
    },

    onConfirmEndData(date) {
      this.showEndData = false;
      this.submitData.expirationTime = this.formatDate(date);
    },


    afterRead(file) {
      var that = this;
      // 此时可以自行将文件上传至服务器
      const formData = new FormData();
      if (file instanceof Array) {
        //判断是否是数组
        file.map((element) => {
          formData.append("uploadfile", element.file);
        });
      } else {
        formData.append("uploadfile", file.file);
      }
      that.uploadMultipartFileAPI(formData, file);
    },

    // 上传附件
    uploadMultipartFileAPI(fromdata, file) {
      var that = this;
      var fileIdList = [];

      that.$Toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      });

      that.$axios
        .post(
          process.env.API_ROOT + "tgy/mobile/attachment/uploadMultipartFile",
          fromdata, {
            headers: {
              enctype: "multipart/form-data",
              Authorization: storage.getUserInfo(),
            },
          }
        )
        .then((res) => {
          if (res.data.code === 200) {
            that.$Notify({
              type: "success",
              message: "上传成功",
            });

            /*res.data.dataList.forEach((element) => {
              fileIdList.push(element.id);
            });*/
            console.log('that.submitData.fileIdList', that.submitData.fileIdList)
            if (that.submitData.fileIdList.length == 0) {
              that.submitData.fileIdList = []
              res.data.dataList.forEach((element) => {
                that.submitData.fileIdList.push(element.id);
              });
            } else {
              fileIdList.push(that.submitData.fileIdList)
              res.data.dataList.forEach((element) => {
                fileIdList.push(element.id);
              });
              that.submitData.fileIdList = fileIdList;
            }

            console.log('fileIdList', that.submitData.fileIdList);

            /*that.submitData.fileIdList = fileIdList.join(",");
             console.log(that.submitData.fileIdList)*/
            that.$Toast.clear();

          }
          console.log(res.data);
        }).catch(function(err) {
          console.log("error", err);
          file.status = 'failed';
          file.message = '上传失败';
          // console.log(file)
          // const Idlist = [ ...that.submitData.fileIdList,'']
          // that.submitData.fileIdList = Idlist.join(",");
          that.$Notify({
            type: "danger",
            message: "上传失败",
          });
          that.$Toast.clear();
        });;
    },

    deleteUploadImg(file, detail) {
      this.uploader.splice(detail.index, 1);
      var data = this.submitData.fileIdList.split(",");

      this.$delete(data, detail.index);
      console.log('data', data)
      this.submitData.fileIdList = data;
    },

    onSubmit() {
      var that = this;
      console.log(that.submitData)
      that.$set(that.submitData, 'id');
      that.$set(that.submitData, 'name');
      that.$set(that.submitData, 'contractImageList');
      that.submitData.fileIdList = that.submitData.fileIdList.toString();
      that.$api
        .contractSaveAPI(that.submitData)
        .then(function(res) {
          if (res.data.code === 200) {
            that.$router.push({ path: "/order/contractFinish" });
          } else {
            that.$Notify({
              type: "danger",
              message: res.data.message,
            });
          }
        })
        .catch(function(err) {
          console.log("error");
        });
    },

    //返回上一页
    goback() {
      this.$router.go(-1);
    },
  },
};

</script>
<style lang="less" scoped>
.contract_browse {
  /deep/ .van-field__control {
    display: flex;
    flex-direction: column;
    width: 100%;
    justify-content: space-between;
    padding: 0px !important;
    margin: 0px !important;
  }

  .data_idcard {
    display: flex;
    flex-direction: column;
    width: 100%;
    justify-content: space-between;
    color: #323233;
    font-size: 14px;

    .idcard_img {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top: 20px;
      width: 100%;

      /deep/ .van-uploader__input-wrapper {
        width: 100%;
        border: 1px solid rgba(0, 0, 0, 0.15);
        height: 150px;
        border-radius: 2px;
        background-color: rgba(0, 0, 0, 0.02);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-top: 10px;
      }

      /deep/ .van-uploader__preview {
        margin: 0px;
        margin-top: 10px;
        width: 100%;
      }

      /deep/ .van-uploader__preview-image {
        width: 100%;
        height: 100%;
      }

      /deep/ .van-image__img{
        object-fit: scale-down !important;
      }

      .img_license {
        width: 100%;
      }
    }
  }

  /deep/ .van-field__control {
    color: #979797;
  }

  .van-button {
    position: fixed;
    bottom: 0px;
    font-size: 16px;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/layout/place/pushContract.vue